module.exports = __webpack_public_path__ + "img/4-2.80b9d379.png";